import React, { Component } from "react";
import MaterialTable from "material-table";
import { IconButton } from "@material-ui/core";
import Icon from "@jll/icon";
import { Pagination, LongText } from "../../../../Component";
import Tooltip from "@material-ui/core/Tooltip";
import { withStyles } from "@material-ui/core/styles";
import styles from "./styles";

import {
  tableStyle,
  tableOptions,
  tableIcons,
} from "../../../../Component/Table/tableCommonStyles";

import { Grid } from "@material-ui/core";
import CustomTableHeader from "../../../../Component/Table/CustomMTableHeader";
import CustomMTableRow from "../../../../Component/Table/CustomTableRow";
import CustomMTableCell from "../../../../Component/Table/CustomMTableCell";
import { LightTooltip } from "../../../../Component";
import Typography from "@material-ui/core/Typography";
import RecordPreview from "../RecordPreview";
import { withTranslation } from "react-i18next";

class DunsResultTable extends Component {
  state = {
    pageSize: 0,
  };

  render() {
    const {
      classes,
      data,
      recordActions,
      totalItemsCount,
      pageNumber,
      rowsPerPage,
      handlePageChange,
      handlePageSizeChange,
      t
    } = this.props;

    return (
      <div className={classes.tableWrapper}>
        <MaterialTable
          style={tableStyle}
          icons={tableIcons}
          elevation="0"
          options={tableOptions}
          isLoading={false}
          data={data}
          localization={{
            header: {
              actions: t('labels.common.table.actions')
            },
            body: {
              emptyDataSourceMessage: t('labels.common.table.noRecordsFound'),
            }
          }}
          columns={[
            {
              title: t("labels.record.search.table.headers.dunsNumber"),
              field: "dunsNumber",
              render: (rowData) => {
                return <span>{rowData.dunsNumber}</span>;
              },
            },
            {
              title: t("labels.record.search.table.headers.recordName"),
              field: "name",
              render: (rowData) => (
                <Grid container style={{ paddingRight: 25 }}>
                  <Grid item xs={10} sm={10} md={10}>
                    <LongText text={rowData.name} />
                  </Grid>
                  <Grid item xs={2} sm={2} md={2}>
                    <LightTooltip title={<RecordPreview data={rowData} />}>
                      <Typography component="span">
                        <Icon
                          style={{
                            paddingLeft: 15,
                            float: "right",
                          }}
                          className="fas fa-info-circle"
                        />
                      </Typography>
                    </LightTooltip>
                  </Grid>
                </Grid>
              ),
            },
            {
              title: t("labels.record.search.table.headers.country"),
              field: "country",
              render: (rowData) => {
                return <span>{rowData.countryIso3}</span>;
              },
            },
            {
              title: t("labels.record.search.table.headers.city"),
              field: "city",
              render: (rowData) => {
                return <span>{rowData.city}</span>;
              },
            },
            {
              title: t("labels.record.search.table.headers.addressLine1"),
              field: "addressLine1",
              render: (rowData) => {
                return <span>{rowData.addressLine1}</span>;
              },
            },

            {
              title: t("labels.record.search.table.headers.stateOrProvince"),
              field: "stateProvince",
              render: (rowData) => {
                return <span>{rowData.stateProvince}</span>;
              },
            },
          ]}
          actions={recordActions}
          components={{
            Action: (props) => {
              return (
                <Tooltip title={props.action.tooltip} placement="bottom">
                  <IconButton
                    className={classes.actionIcons}
                    onClick={(event) => props.action.onClick(event, props.data)}
                  >
                    <Icon
                      className={props.action.icon}
                      style={{ fontSize: 16 }}
                    />
                  </IconButton>
                </Tooltip>
              );
            },
            Header: (props) => <CustomTableHeader {...props} />,
            Row: (props) => <CustomMTableRow {...props} />,
            Cell: (props) => <CustomMTableCell {...props} />,
          }}
        />
        <Pagination
          handleRowsPerPage={handlePageSizeChange}
          rowsPerPage={rowsPerPage}
          pageNumber={pageNumber}
          handlePagination={handlePageChange}
          totalItemsCount={totalItemsCount}
        ></Pagination>
      </div>
    );
  }
}

export default withTranslation()(withStyles(styles, { withTheme: true })(DunsResultTable));
